import React, { useEffect } from "react";
import ItemHolder from "../lookUp/ItemHolder";
import Checkbox from "../misc/elements/Checkbox";

const PickListModal = ({ onItemPicked, itemList, pickedItems }) => {
  return (
    <div className="divColumn" style={{ maxHeight: "100px", overflow: "auto" }}>
      {itemList
        .sort((a, b) => (a.value < b.value ? 1 : -1))
        .map((i) => (
          <Item
            item={i}
            key={i.key}
            pickedItems={pickedItems}
            onClick={onItemPicked}
          />
        ))}
    </div>
  );
};

const Item = ({ item, pickedItems, onClick }) => {
  return (
    <div className="divRow">
      <Checkbox
        item={item.key}
        includeList={pickedItems}
        background="#2f2f2f"
        size="18"
      />
      <ItemHolder item={item} onClick={onClick} />
    </div>
  );
};

export default PickListModal;
